import { render } from "./toadVue.vue?vue&type=template&id=4d45bdce&lang=true"
import script from "./toadVue.vue?vue&type=script&lang=js"
export * from "./toadVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__